/**
 * Premium Card Component
 * Reusable glass card with hover effects and variants
 */

export const Card = ({
  children,
  className = '',
  variant = 'default',
  hover = false,
  padding = 'lg',
  ...props
}) => {
  const variants = {
    default: 'bg-white border border-gray-200 shadow-sm',
    subtle: 'bg-gray-50 border border-gray-200',
    strong: 'bg-white shadow-md border-t-4 border-indigo-500',
  }

  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    xl: 'p-12'
  }

  return (
    <div
      className={`
        ${variants[variant]}
        ${paddings[padding]}
        ${hover ? 'hover-lift' : ''}
        rounded-2xl
        ${className}
      `.trim().replace(/\s+/g, ' ')}
      {...props}
    >
      {children}
    </div>
  )
}

/**
 * Premium Card Header Component
 * Consistent across all admin pages: icon p-3, title text-3xl, subtitle text-sm text-gray-500
 */
export const CardHeader = ({
  icon: Icon,
  title,
  subtitle,
  iconColor = 'from-indigo-400 to-indigo-600',
  children,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-4 mb-8 ${className}`}>
      {Icon && (
        <div className={`p-3 rounded-xl bg-gradient-to-br ${iconColor} shadow-lg shrink-0`}>
          <Icon className="text-white" size={22} />
        </div>
      )}
      <div className="flex-1 min-w-0">
        {title && <h2 className="text-3xl font-bold text-gray-900 leading-tight">{title}</h2>}
        {subtitle && <p className="text-gray-500 text-sm mt-0.5">{subtitle}</p>}
        {children}
      </div>
    </div>
  )
}
